import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Settings, User } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTurnkeyWallet } from '@/providers/TurnkeyProvider';
import { SidebarFooter } from './SidebarFooter';
import { NAVIGATION_ITEMS } from '@/lib/constants/navigation';
import { Badge } from '@/components/ui/badge';


const LeftRail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { walletAddress, connected } = useTurnkeyWallet();
  const isProfileActive = location.pathname === '/profile' || location.pathname.startsWith('/creator/');
  const isSettingsActive = location.pathname.startsWith('/settings');

  const handleProfileClick = () => {
    if (connected && walletAddress) {
      navigate('/creator/' + walletAddress);
    } else {
      navigate('/profile');
    }
  };
  return <aside className="fixed left-0 top-0 h-[100dvh] w-52 bg-background border-r border-border flex flex-col z-50">
      {/* Logo - full dextoro logo image */}
      <Link to="/" className="no-min-touch h-14 flex items-center px-4 shrink-0">
        <img
          alt="dextoro"
          className="h-7 w-auto hover:opacity-80 transition-opacity"
          src="/dextoro-logo.png"
        />
      </Link>

      {/* Divider */}
      <div className="border-b border-border/50 mx-4 mb-3" />

      {/* Navigation */}
      <nav className="flex-1 flex flex-col gap-0.5 px-3 overflow-y-auto">
        {NAVIGATION_ITEMS.map(item => {
          const isActive =
            location.pathname === item.path ||
            (item.path !== '/' && location.pathname.startsWith(item.path)) ||
            (item.activePaths?.some(p => location.pathname.startsWith(p)) ?? false);
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                'no-min-touch flex items-center gap-3 px-3 h-9 rounded-lg text-sm font-medium transition-colors',
                isActive
                  ? 'bg-white/10 text-primary font-semibold'
                  : 'text-foreground hover:bg-white/5 hover:text-primary'
              )}
            >
              <item.icon className="w-4 h-4 flex-shrink-0" />
              <span className="truncate">{item.label}</span>
              {item.badge && (
                <Badge
                  variant={(item.badgeVariant as any) || 'default'}
                  pulse={item.badgeVariant === 'live'}
                  className="ml-auto px-1.5 py-px text-[10px]"
                >
                  {item.badge}
                </Badge>
              )}
            </Link>
          );
        })}

        {/* Profile */}
        <button
          onClick={handleProfileClick}
          className={cn(
            'no-min-touch flex items-center gap-3 px-3 h-9 rounded-lg text-sm font-medium transition-colors text-left',
            isProfileActive
              ? 'bg-white/10 text-primary font-semibold'
              : 'text-foreground hover:bg-white/5 hover:text-primary'
          )}
        >
          <User className="w-4 h-4 flex-shrink-0" />
          <span className="truncate">Profile</span>
        </button>

        {/* Settings */}
        <Link
          to="/settings"
          className={cn(
            'no-min-touch flex items-center gap-3 px-3 h-9 rounded-lg text-sm font-medium transition-colors',
            isSettingsActive
              ? 'bg-white/10 text-primary font-semibold'
              : 'text-foreground hover:bg-white/5 hover:text-primary'
          )}
        >
          <Settings className="w-4 h-4 flex-shrink-0" />
          <span className="truncate">Settings</span>
        </Link>
      </nav>

      {/* Secondary Navigation Footer */}
      <SidebarFooter />
    </aside>;
};
export default LeftRail;
